module.exports = __webpack_public_path__ + "img/phoneIcon.c1e82b47.svg";